import React from "react";
import { cn } from "../lib/utils";

type Variant = "top" | "above" | "bottom" | "below" | "center";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
}

// Soft dual radial glow
export default function Glow({ className, variant = "top", ...props }: Props) {
  const variantClass =
    variant === "top"
      ? "top-0"
      : variant === "above"
      ? "-top-[128px]"
      : variant === "bottom"
      ? "bottom-0"
      : variant === "below"
      ? "-bottom-[128px]"
      : "top-1/2 -translate-y-1/2";

  return (
    <div data-slot="glow" className={cn("pointer-events-none absolute w-full", variantClass, className)} {...props}>
      <div
        className={cn(
          "absolute left-1/2 h-[256px] w-[60%] -translate-x-1/2 rounded-[50%] blur-3xl opacity-30 sm:h-[512px]",
        )}
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(199,210,254,0.35) 10%, rgba(199,210,254,0.0) 60%)",
        }}
      />
      <div
        className={cn(
          "absolute left-1/2 h-[128px] w-[40%] -translate-x-1/2 rounded-[50%] blur-2xl opacity-40 sm:h-[256px]",
        )}
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(99,102,241,0.30) 10%, rgba(99,102,241,0.0) 60%)",
        }}
      />
    </div>
  );
}
